import { productsSlugs } from 'constants/products';

export const productsMetadata = {
  [productsSlugs.CONDITIONER]: {
    description:
      'Personalized to your unique hair, Prose Custom Conditioner is a nourishing formula to smooth, soften, and hydrate. Always made to order. Always just for you.',
    title: 'Custom Conditioner – Prose | Haircare',
  },
  [productsSlugs.CURL_CREAM]: {
    description:
      'Personalized to your natural texture, Prose Custom Curl Cream keeps curls, coils, and waves hydrated and frizz-free. Always made to order. Always just for you.',
    title: 'Custom Curl Cream – Prose | Haircare',
  },
  [productsSlugs.DRY_SHAMPOO]: {
    description:
      'Refresh your roots with Prose Custom Dry Shampoo — a non-aerosol formula personalized to your unique scalp needs. Always made to order. Always just for you.',
    title: 'Custom Dry Shampoo – Prose | Haircare',
  },
  [productsSlugs.HAIR_MASK]: {
    description:
      'Restore moisture and shine with Prose Custom Hair Mask — a pre-shampoo treatment personalized to your unique goals. Always made to order. Always just for you.',
    title: 'Custom Hair Mask – Prose | Haircare',
  },
  [productsSlugs.HAIR_OIL]: {
    description:
      'Shop Prose Custom Hair Oil — a nurturing, silicone-free formula with natural oils to smooth, tame, and restore hair. Always made to order. Always just for you.',
    title: 'Custom Hair Oil – Prose | Haircare',
  },
  [productsSlugs.LEAVEIN_CONDITIONER]: {
    description:
      'Hydrate, detangle, and protect hair from heat styling damage up to 450°F with Prose Custom Leave-In Conditioner. Always made to order. Always just for you.',
    title: 'Custom Leave-In Conditioner – Prose | Haircare',
  },
  [productsSlugs.OIL]: {
    description:
      'Shop Prose Custom Hair Oil — a nurturing, silicone-free formula with natural oils to smooth, tame, and restore hair. Always made to order. Always just for you.',
    title: 'Custom Hair Oil – Prose | Haircare',
  },
  [productsSlugs.SCALP_MASK]: {
    description:
      'Purify, soothe, and restore scalp balance with Prose Custom Scalp Mask. Fragrance-free + suitable for sensitive scalps. Always made to order. Always just for you.',
    title: 'Custom Scalp Mask – Prose | Haircare',
  },
  [productsSlugs.SHAMPOO]: {
    description:
      'Discover Prose Custom Shampoo — a clarifying, sulfate-free shampoo personalized to your unique hair and scalp type. Always made to order. Always just for you.',
    title: 'Custom Shampoo – Prose | Haircare',
  },
  [productsSlugs.STYLING_GEL]: {
    description:
      'Prose Custom Styling Gel is personalized for lightweight, flexible, flake-free hold — no matter your hairstyle. Always made to order. Always just for you.',
    title: 'Custom Styling Gel – Prose | Haircare',
  },
  [productsSlugs.CLEANSER]: {
    description:
      'Shop Prose Custom Cleanser — a gentle face wash tailored to your skin type and proven to preserve skin hydration. Always made to order. Always just for you.',
    title: 'Custom Face Cleanser & Face Wash – Prose | Skincare',
  },
  [productsSlugs.MOISTURIZER]: {
    description:
      'Discover Prose Custom Moisturizer — a nourishing formula personalized with powerful, skin-boosting ingredients. Always made to order. Always just for you.',
    title: 'Custom Face Moisturizer – Prose | Skincare',
  },
  [productsSlugs.SERUM]: {
    description:
      'Personalized with potent, clinically tested ingredients, Prose Custom Serum reveals hydrated, healthy-looking skin. Always made to order. Always just for you.',
    title: 'Custom Face Serum – Prose | Skincare',
  },
  [productsSlugs.SCALP_SERUM]: {
    description:
      'Shop Prose Custom Scalp Serum — a 99% natural formula to nourish your scalp and boost hair fullness and density. Always made to order. Always just for you.',
    title: 'Custom Scalp Serum – Prose | Haircare',
  },
};
